// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n'; // инициализация локализации
import App from './App';
import { installDisableAutocorrect } from './utils/disable-autocorrect';

// SaaS-приложение: вводим свои названия товаров/имена/артикулы,
// автокоррекция мешает (особенно с кириллицей при потере фокуса).
installDisableAutocorrect();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
